import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Keeps the chat shell (`ChatWithCollectivIQ`) mounted when navigating between
 * its sibling surfaces: `/chat`, `/chat/workspace/:view`,
 * `/chat/ddr/room/:roomId`, `/chat/ddr/dm/:personaId`. They're separate route
 * configs that all load the same component, so the default strategy destroys
 * and recreates the component on every cross-surface nav — which re-mounts the
 * sidebar (scroll jumps to top, personas re-fetch with a loading flash). Reusing
 * the route keeps the component (and its sidebar) alive; the shell already
 * reacts to the new URL via its navigation effect, so the surface still swaps.
 *
 * Only chat-to-chat navigation is reused; anything else falls back to the
 * default config-equality behavior.
 */
export class ChatShellReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        if (this.isChatShell(future) && this.isChatShell(curr)) {
            return true;
        }
        return super.shouldReuseRoute(future, curr);
    }

    private isChatShell(snapshot: ActivatedRouteSnapshot): boolean {
        const path = snapshot.routeConfig?.path;
        return path === 'chat' || (typeof path === 'string' && path.startsWith('chat/'));
    }
}
